(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const STORAGE_KEY = 'lumano:motion-played:v1';
  const pageKey = `text-reveal:${window.location.pathname}`;

  const loadPlayedSet = () => {
    try {
      return new Set(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'));
    } catch {
      return new Set();
    }
  };

  const markPlayed = (key) => {
    const played = loadPlayedSet();
    if (played.has(key)) return;
    played.add(key);
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...played]));
    } catch {
      /* sessionStorage may be unavailable */
    }
  };

  const hasPlayed = (key) => loadPlayedSet().has(key);

  const textRevealSelector = [
    '.main-page-title',
    '.collection-hero__title',
    '.template-search__header h1',
    '.product__title h1',
    '.product__description h2',
    '.product__description h3',
    '.related-products__heading',
    '.footer-block__heading',
    '.lumano-footer__newsletter h2',
    '.article-template__title',
    '.blog-articles__title',
  ].join(',');

  const textObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          markPlayed(pageKey);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' })
    : null;

  const revealText = (scope = document) => {
    const elements = [...scope.querySelectorAll(textRevealSelector)]
      .filter((element) => !element.closest('.lumano-home') && !element.dataset.lumanoTextReveal);

    if (!elements.length) return;

    if (hasPlayed(pageKey)) {
      elements.forEach((element) => {
        element.dataset.lumanoTextReveal = 'true';
        element.classList.add('is-revealed');
      });
      return;
    }

    const sectionCounts = new Map();
    elements.forEach((element) => {
      element.dataset.lumanoTextReveal = 'true';
      const rect = element.getBoundingClientRect();
      const initiallyVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (reduceMotion || !textObserver || initiallyVisible) {
        element.classList.add('is-revealed');
        markPlayed(pageKey);
        return;
      }

      const section = element.closest('.shopify-section') || element.parentElement;
      const order = Math.min(sectionCounts.get(section) || 0, 3);
      sectionCounts.set(section, order + 1);
      element.style.setProperty('--lumano-reveal-delay', `${order * 44}ms`);
      element.classList.add('lumano-text-reveal-pending');
      textObserver.observe(element);
    });
  };

  revealText();
  document.addEventListener('shopify:section:load', (event) => revealText(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-lumano-text-reveal]').forEach((element) => textObserver?.unobserve(element));
  });
})();
